function checkURLFilters() {
    var queryString = window.location.search;
    if (queryString.length > 0) {
      var urlParams = new URLSearchParams(queryString);
      if (urlParams.has('filter.v.availability')) {
        var filterValues = urlParams.getAll('filter.v.availability');
        // console.log('Filters:', filterValues);
        hideElement_a();
      }
       else if (areFiltersInURL_global()) {
          showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
        }
      else if (areFiltersInURL_vendor()) {
          showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
        }
        else if (areFiltersInURL_vendor_()) {
             // alert("hii");
             showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
        }
      else {
        // console.log('No filters found in the URL.');
        hideElement();
         hideElement_();
      }
    } else {
      // console.log('No filters found in the URL.');
      hideElement();
      hideElement_(); 
    }
  }
  document.addEventListener('DOMContentLoaded', checkURLFilters);
   function hideElement() {
    var elementsToHide = document.querySelectorAll('#CollectionAjaxContent');
    elementsToHide.forEach(function(element) {
      element.style.display = 'none';
    });
  }
  function hideElement_() {
    var elementsToHide = document.querySelectorAll('.custom-collection .pagination');
    elementsToHide.forEach(function(element) {
      element.style.display = 'none';
    });
  }
function areFiltersInURL() {
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  return urlParams.has('filter.v.availability');
}
function areSpecificFiltersInURL(filters) {
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  for (var i = 0; i < filters.length; i++) {
    if (!urlParams.has(filters[i])) {
      return false;
    }
  }
  return true;
}
function updateURL() {
  var filters = [];
  checkboxes.forEach(function (checkbox) {
    if (checkbox.checked) {
      filters.push(checkbox.value);
      console.log("hii");
    }
    else{
      console.log("by");
    }
  });
  var newURL = window.location.pathname + '?' + 'filter.v.availability=' + filters.join(',');
  window.history.replaceState(null, null, newURL);
  var specificFiltersPresent = areSpecificFiltersInURL(['filter.v.availability=instock', 'filter.v.availability=stock']);
  
  if (!specificFiltersPresent) {
    hideElement_a();
  } else {
    showElement_a();
  }
  showElement();
  showElement_();
 
    if (!event.target.checked) {
                    // Add your condition here
                    console.log(`Checkbox with value ${event.target.value} is unchecked!`);
                    // Perform any other actions required when the checkbox is unchecked
                    
                }
}
var checkboxes = document.querySelectorAll('input[name="filter.v.availability"]');
checkboxes.forEach(function (checkbox) {
  checkbox.addEventListener('change', updateURL);
  // alert("hi");
});
function hideElement_a() {
  var elementsToHide = document.querySelectorAll('.main_container');
  elementsToHide.forEach(function (element) {
    element.classList.add('hide_main_container');
   element.classList.remove('Show_main_container');
  });
}
function showElement_a() {
  var elementsToShow = document.querySelectorAll('.main_container');
  elementsToShow.forEach(function (element) {
    element.classList.add('Show_main_container');
    element.classList.remove('hide_main_container');
  });
}
function showElement() {
  var elementsToShow = document.querySelectorAll('#CollectionAjaxContent');
  elementsToShow.forEach(function (element) {
    element.style.display = 'block';
  });
}
function showElement_() {
  var elementsToShow = document.querySelectorAll('.custom-collection .pagination');
  elementsToShow.forEach(function (element) {
    element.style.display = 'block';
  });
}
$(document).on('click', '.tag--remove', function(){
  var queryString = window.location.href;
  // console.log($(this).parent('.tag-list li').length);
   if (areFiltersInURL()) {
       $(".tag__checkbox-wrapper").removeClass('tag__checkbox_');
       showElement();
       showElement_();
       hideElement_a();
    }
    else if (areFiltersInURL_global()) {
          clickedElement.removeClass('tag__checkbox_');
          showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
           
        }
      else if (areFiltersInURL_vendor()) {
          showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
            clickedElement.removeClass('tag__checkbox_');
        }
         else if (areFiltersInURL_vendor_()) {
             // alert("hii");
             showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
            clickedElement.removeClass('tag__checkbox_');
        }
   else {
      hideElement();
      hideElement_();
     $(".tag__checkbox-wrapper").removeClass('tag__checkbox_');
     $(".main_container").removeClass('hide_main_container'); 
    }
});
$(document).on('click', '.tag__checkbox-wrapper', function () {
    var clickedElement = $(this);
   // alert('hii');
    // console.log("Parent Element Length:", clickedElement.parent('.tag-list li').length);
    setTimeout(function () {
        var queryString = window.location.search;
        // console.log("QueryString:", queryString);
        
        if (areFiltersInURL_()) {
            clickedElement.toggleClass('tag__checkbox_');
            showElement();
            showElement_();
            hideElement_a();
            setDelayedTimeout();
            
        }
        else if (areFiltersInURL_global()) {
          clickedElement.toggleClass('tag__checkbox_');
          showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
            setDelayedTimeout();
        }
          else if (areFiltersInURL_vendor()) {
          clickedElement.toggleClass('tag__checkbox_');  
          showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
            setDelayedTimeout();
        }
             else if (areFiltersInURL_vendor_()) {
             // alert("hii");
            clickedElement.toggleClass('tag__checkbox_');  
             showElement();
            showElement_();
            console.log("Filter is available areFiltersInURL_global");
            hideElement_a();
             setDelayedTimeout();
        }
        else {
            hideElement();
            hideElement_();
            console.log("Filter is not available");
            $(".main_container").removeClass('hide_main_container'); 
        }
      
    }, 100);
});
function areFiltersInURL_() {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    return urlParams.has('filter.v.availability');
}
function containsStringInURL(needle) {
    var urlString = window.location.href;
    return urlString.includes(needle);
}

function areFiltersInURL_global() {
    var result = containsStringInURL('filter.p.m.global');
    // console.log('URL contains "filter.p.m.global":', result);
    return result;
}
function areFiltersInURL_vendor() {
    var result = containsStringInURL('filter.p.vendor');
    // console.log('URL contains "filter.p.vendor":', result);
    return result;
}
function areFiltersInURL_vendor_() {
    var result = containsStringInURL('filter.p.m.custom');
    // console.log('URL contains "filter.p.vendor":', result);
    return result;
}
 function delayedFunction() {
      $('.closebtn').trigger('click');
    }

    // Function to set a timeout and call the delayed function
    function setDelayedTimeout() {
      setTimeout(delayedFunction, 1500);
    }


// mandasa custom js
  document.addEventListener("DOMContentLoaded", function() {
    // Get the element you want to modify
    var contentElement = document.querySelector('.header-section_');
    var contentElement_ = document.querySelector('.header_sticky__');
    // Function to add a class on scroll
    function addClassOnScroll() {
      if (window.scrollY > 20) {  // Check if scrolled more than 40px
        contentElement.classList.add('highlight');
         contentElement_.classList.add('highlight_ms'); 
      } else {
        contentElement.classList.remove('highlight');
        contentElement_.classList.remove('highlight_ms');
      }
    }

    // Add scroll event listener
    window.addEventListener('scroll', addClassOnScroll);
  });
   $(".slide-nav__item").each(function() {
        var dropdown = $(this).find(".slide-nav__dropdown");
        var toggleButton = $(this).find(".js-toggle-submenu_");

        if (dropdown.is(":visible")) {
            toggleButton.addClass("minus-icon rotate180").removeClass("plus-icon");
        } else {
            toggleButton.addClass("plus-icon").removeClass("minus-icon rotate180");
        }
    });

    // Click event handler
    // $(".js-toggle-submenu_").click(function() {
    //     // Find the parent .slide-nav__item of the clicked element
    //     var parentItem = $(this).closest(".slide-nav__item");

    //     // Find the child .slide-nav__dropdown within the parent .slide-nav__item
    //     var dropdown = parentItem.find(".slide-nav__dropdown");

    //     // Toggle the visibility of the dropdown with animation
    //     dropdown.slideToggle(300);

    //     // Toggle plus and minus icons with animation
    //     $(this).toggleClass("plus-icon minus-icon rotate180");
    // });
// mandasa custom js 
// Get the element to add/remove the class
const element = document.querySelector('#HeaderCartTrigger');
const animateElement = document.querySelector('.site-header__drawer-animate');
const animateElement_ss = document.querySelector('.site-header__drawer');

// Function to toggle class on hover
function toggleClassOnHover() {
    animateElement.classList.toggle('active_cart');
    animateElement_ss.classList.toggle('active_cart_1');
}

// mandasa custom js
 var divElement = document.querySelector("#HeaderWrapper");
    var elemHeight = divElement.clientHeight;
    console.log(elemHeight);


 var divElement__ = document.querySelector(".header--sticky-placeholder_mt");
    // Calculate padding top value (for example, 20 pixels)
    var paddingTopValue = elemHeight;
    
    // Set the padding top of the element
    divElement__.style.paddingTop = paddingTopValue + "px";

jQuery(function($){
	var topMenuHeight = $(".alphabet").outerHeight();
	$(".alphabet").menuScroll(topMenuHeight);
});

// COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
jQuery.fn.extend({
    menuScroll: function(offset) {
		// Declare all global variables
        var topMenu = this;
		var topOffset = offset ? offset : 0;
        var menuItems = $(topMenu).find("a");
        var lastId;
	
		// Save all menu items into scrollItems array
        var scrollItems = $(menuItems).map(function() {
            var item = $($(this).attr("href"));
            if (item.length) {
                return item;
            }
        });

		// When the menu item is clicked, get the #id from the href value, then scroll to the #id element
        $(topMenu).on("click", "a", function(e){
            var href = $(this).attr("href");
            
           
           if (window.matchMedia("(max-width: 767px)").matches) {
              var offsetTop = href === "#" ? 0 : $(href).offset().top - 200; // Adjusted offset to 100px
           }
          else{
             var offsetTop = href === "#" ? 0 : $(href).offset().top - 150; // Adjusted offset to 100px
          }


            $('html, body').stop().animate({ 
                scrollTop: offsetTop
            }, 300);
            e.preventDefault();

        });
		
		// When page is scrolled
        $(window).scroll(function(){
            var nm = $("html").scrollTop();
            var nw = $("body").scrollTop();
            var fromTop = (nm > nw ? nm : nw)+topOffset;

			
			// When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
            var current = $(scrollItems).map(function(){
                if ($(this).offset().top <= fromTop)
                return this;
            });
			
			// Get the most recent passed section from current array
            current = current[current.length-1];
            var id = current && current.length ? current[0].id : "";
            if (lastId !== id) {
                lastId = id;
                // Set/remove active class
                $(menuItems)
                .parent().removeClass("active")
                .end().filter("[href='#"+id+"']").parent().addClass("active");
            }      

        });
    }
});
// document.addEventListener('DOMContentLoaded', function() {
//     var url = window.location.href;
//     var cleanUrl = url.replace(/(\?|\&)gender=[^&]*(&|$)/, '$1').replace(/(\?|\&)$/, '');
//     if (cleanUrl !== url) {
//         history.replaceState(null, null, cleanUrl);
//     }
// });
// $ = function(id) {
//   return document.getElementById(id);
// }

// var show = function(id) {
// 	$(id).style.display ='block';
//     console.log(id);
// }
// var hide = function(id) {
// 	$(id).style.display ='none';
// }
// document.addEventListener('DOMContentLoaded', function() {
//   var targetElementId = '#popup'; // Replace with the ID of the element you want to hide

//   // Show the element for demonstration purposes
//   show(targetElementId);

//   // Add click event listener to the document
//   document.addEventListener('click', function(event) {
//     var targetElement = $(targetElementId);
//     var isClickInside = targetElement.contains(event.target);

//     if (!isClickInside) {
//       hide(targetElementId);
//     }
//   });
// });
$(".Click-here").on('click', function() {
  $(".custom-model-main").addClass('model-open');
  $("body").addClass('hidden_mt');
}); 
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
  $("body").removeClass('hidden_mt');
});
// remove autoplay on mobileview

//  document.addEventListener('DOMContentLoaded', function () {
//   var video = document.getElementById('vidWindow');
//   var playButton = document.getElementById('playButton');
//   var playIcon = document.getElementById('playIcon');
//   var pauseIcon = document.getElementById('pauseIcon');

//   function isMobile() {
//       return window.innerWidth <= 768; 
//   }
//   function handleMobileView() {
//       if (isMobile()) {
//           video.removeAttribute('autoplay');
//            video.removeAttribute('controls');
//           playButton.style.display = 'block';
//       } else {
//           playButton.style.display = 'none';
//       }
//   }
//   playButton.addEventListener('click', function () {
//       if (video.paused) {
//           video.play();
//           playIcon.style.display = 'none';
//           pauseIcon.style.display = 'block';
//       } else {
//           video.pause();
//           playIcon.style.display = 'block';
//           pauseIcon.style.display = 'none';
//       }
//   });

//   handleMobileView();
//   window.addEventListener('resize', handleMobileView);
// });
 var selectedValue = $('input[name="properties[Ring Size]"]:checked').val();
 console.log('Selected Ring Size:', selectedValue);
  var input_k = $('.Ring-size-mt').val(selectedValue);
$(".variant-input_mt input").change(function() {

      var inputValue = $(this).val();
      
       var input_kk = $('.Ring-size-mt').val(inputValue);
       console.log(input_kk);
});


$(document).ready(function() {
    var $element = $('span[data-add-to-cart-text]');
    if ($element.length > 0) {
        var soldOutText = $element.text().trim();
        console.log(soldOutText); // This will log "Sold Out" to the console
        
        $('.customaddtocart').text(soldOutText)
    } else {
        console.log('Element not found');
    }
});



function getOptionName() {
    return $('.custommetal').closest('fieldset').attr('name');
}

function isMetalSelected() {
    var metalOptionExists = $('.custommetal').length > 0;
    var metalSelected = $('.custommetal input[type="radio"]:checked').length > 0;
    if (metalOptionExists && !metalSelected) {
        var optionName = getOptionName(); // Get the option name
        $('#option-name-placeholder').text(optionName); // Set the option name in the alert
    }
    return !metalOptionExists || metalSelected; // True if metal option doesn't exist or is selected
}

$('#add-to-cart-button').click(function(event) {
    $('#metal-alert').hide();

    if (!isMetalSelected()) {
        event.preventDefault(); // Prevent adding to cart
        $('#metal-alert').show(); // Show metal alert
        $(this).addClass('disabled-add-to-cart');
    } else {
        $(this).removeClass('disabled-add-to-cart'); // Enable Add to Cart
    }
});

$(document).ready(function() {  
  if ($('.product-single__meta').find('.variant-wrapper').length) {
        $('.customsalesvariant').css('display', 'none');
    }
   
    $('#add-to-cart-button').addClass('disabled-add-to-cart');

    $('.custommetal input[type="radio"]').change(function() {
        if (isMetalSelected()) {
            $('#metal-alert').hide(); 
            $('#add-to-cart-button').removeClass('disabled-add-to-cart'); 
        } else {
            $('#add-to-cart-button').addClass('disabled-add-to-cart'); 
        }
       $('.customsalesvariant').css('display', 'block');
    });

  
    $(".variant-input input").change(function() { 
        var $element_ = $('span[data-add-to-cart-text]');
        var data_size = $(this).attr('data-size');
        var inventory_policy = $(this).attr('data-inventory-policy');
       
        if ($element_.length > 0) {
            var soldOutText_ = $element_.text().trim();
            $('.customaddtocart').text(soldOutText_);
        } else {
            console.log('Element not found');
        }

    });

    // Handle URL parameters on page load (if any)
    const urlParams_ = new URLSearchParams(window.location.search);
    const variantId = urlParams_.get('variant');
    var optionValue = $('select.product-single__variants option').attr('data-length');
    if (optionValue !== '1') {
        if (variantId) {
            $('#add-to-cart-button').removeClass('disabled-add-to-cart');
          
        } else {
           
            $('.variant-input input').removeAttr("checked");
            $('#add-to-cart-button').addClass('disabled-add-to-cart');
            $('select.product-single__variants').attr('selected', 'selected');
        }
    }


if ($('input.custominputvariant').is(':checked')) {
   $('.customsalesvariant').css('display', 'block');
}
  
});




